import React from 'react';
import BackupForm from './BackupForm';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import BackupTable from './BackupTable';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(theme => ({
  reportHeader: {
    paddingTop: theme.spacing(3),
    textAlign: 'center',
  },
}));

const Backup = ({ machines, backups }) => {
  const classes = useStyles();
  
  return (
    <>
      <h1 className={classes.reportHeader}>
        <FormattedMessage id="menu.main.settings.backup" defaultMessage="Backups" />
      </h1>
      <BackupForm machines={machines} />
      <BackupTable backups={backups} />
    </>
  );
};

const decorate = compose(
  connect(
    store => ({
      machines: store.user.machines,
      backups: store.user.backups,
      
    }),
  ));

export default decorate(Backup);


